<div class="period-picker">
  <div class="adb-segmented" role="radiogroup" aria-label="Period" data-testid="period-picker">
    <button *ngFor="let option of options" type="button" role="radio" class="adb-segmented__option"
            [attr.aria-checked]="option.key === value" [attr.data-testid]="'period-' + option.key"
            (click)="onChange(option.key)">{{ option.label }}</button>
  </div>
  <span class="period-picker__compare" data-testid="period-compare">{{ compareText }}</span>
</div>
